// Séries do GRI Standards 2021. A chave é o que vai/vem do backend; o rótulo é
// só de exibição.
export const GRI_SERIES_OPTIONS = [
 { value: 'universal', label: 'Universal' },
 { value: 'economica', label: 'Econômica' },
 { value: 'ambiental', label: 'Ambiental' },
 { value: 'social', label: 'Social' },
];

export const GRI_SERIES_LABELS = GRI_SERIES_OPTIONS.reduce(
 (acc, option) => ({ ...acc, [option.value]: option.label }),
 {}
);

export const GRI_SERIES_COLORS = {
 universal: 'gray',
 economica: 'blue',
 ambiental: 'green',
 social: 'purple',
};

const SERIES_CONHECIDAS = GRI_SERIES_OPTIONS.map((option) => option.value);

/**
 * Ordena uma lista de séries: conhecidas primeiro (ordem do catálogo acima),
 * série nova em ordem alfabética depois. Usado pelos dashboards (leitura) —
 * NÃO usar em telas de cadastro de indicador, que continuam restritas às 4
 * conhecidas pelo CHECK constraint do banco (`GRI_SERIES_OPTIONS` acima).
 */
export function ordenarSeries(series) {
 const conhecidas = SERIES_CONHECIDAS.filter((s) => series.includes(s));
 const desconhecidas = series.filter((s) => !SERIES_CONHECIDAS.includes(s)).sort();
 return [...conhecidas, ...desconhecidas];
}

/**
 * Rótulo pra exibir uma série nos dashboards. Série nova sem tradução
 * cadastrada ainda aparece com o valor cru capitalizado — nunca escondida.
 */
export function rotuloDaSerie(series) {
 return GRI_SERIES_LABELS[series] || (series.charAt(0).toUpperCase() + series.slice(1));
}
